import { styled } from '@swibeco/shared';

export const HomePageWrapper = styled.div`
  min-height: 70vh;
  .experience-feedback-container {
    padding: 0;
  }
`;
